import { render, staticRenderFns } from "./PosLayout.vue?vue&type=template&id=5a52b368&scoped=true&"
import script from "./PosLayout.vue?vue&type=script&lang=js&"
export * from "./PosLayout.vue?vue&type=script&lang=js&"
import style0 from "../styles/pos-layout.css?vue&type=style&index=0&id=5a52b368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52b368",
  null
  
)

export default component.exports